import { useQuery, UseQueryOptions, QueryKey } from '@tanstack/react-query';
import { request } from 'app/network';
import { ApiParams } from 'app/network/types/ApiTypes';

/**
 * Standardized data fetching hook for MediInStep.
 * Wraps React Query's useQuery with application specific error handling and typing.
 *
 * @param apiName - The API endpoint name (e.g. "User.list")
 * @param params - API parameters (optional)
 * @param options - React Query options (optional)
 */
export function useApiQuery<TData = any>(
    apiName: string,
    params?: ApiParams,
    options?: Omit<UseQueryOptions<TData, Error, TData, QueryKey>, 'queryKey' | 'queryFn'>
) {
    return useQuery<TData, Error>({
        queryKey: [apiName, params],
        queryFn: async () => {
            const response = await request(apiName, { paramz: params });
            // request returns the full response object, but usually we just want data.
            // Adjust this if request API changes.
            return response.data;
        },
        ...options,
    });
}
